import { Locale } from '@mai-team-amusement/core';
import type { AppNamespace, LeafKey } from '@mai-team-amusement/i18n';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { enUs, type ReportResources } from './en-US.js';
import { ja } from './ja.js';
import { zhHans } from './zh-Hans.js';
import { zhHant } from './zh-Hant.js';

export const REPORT_NAMESPACE = 'report';

export const reportResources: Record<Locale, ReportResources> = {
  [Locale.ZhHans]: zhHans,
  [Locale.ZhHant]: zhHant,
  [Locale.EnUs]: enUs,
  [Locale.Ja]: ja,
};

export const reportNamespace: AppNamespace = { name: REPORT_NAMESPACE, resources: reportResources };

export type ReportKey = LeafKey<ReportResources>;

export type ReportTranslate = (
  key: ReportKey,
  values?: Readonly<Record<string, string | number>>,
) => string;

/** Type-checked translator for this app's namespace. */
export function useReportT(): ReportTranslate {
  const { t } = useTranslation(REPORT_NAMESPACE);
  return useCallback<ReportTranslate>((key, values = {}) => t(key, values), [t]);
}
